import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cards',
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.scss'],
})
export class CardsComponent implements OnInit {

  constructor(
    private router: Router
  ) { }

  ngOnInit() {}

  goBack(){
    window.history.back();
  }

  go(){
    this.router.navigate(["tabs/checkin/payment"], {queryParams: {addPayment: true}});
  }
}
